import { MaterialLinkTypes } from "./data/statuses/issue";

export enum API {
    cargoTypes = '/transport-cargo-types',
    categories = '/categories',
    deliveryTimeRange = '/transport-delivery-time-range',
    projects = '/projects',
    requests = '/transport-requests',
    requestTypes = '/transport-request-types',

    //users
    users = '/users',
    allUsers = '/all-users',

    // transport
    trOrders = '/transport-orders',

    //machines
    machines = '/machines',
    //machine service
    machinesService = '/get_next_service',

    //issues
    issue = '/issue',
    issueMaterial = '/material/' + MaterialLinkTypes.ISSUE,
    issueUsers = 'issue/users',

    periodicCheck = '/periodic-check',
    derpartments = '/departments',
    tenant = '/tenant',

    // tasks
    tasks = "/tasks",

    // project chat
    chatProjectDetail = '/chat/get_project_detail',
    getCurrentChatHistory = '/get_current_chat_history',
    addUserToChat = '/add_user_to_chat',
    chatUpload = '/chat/upload',
    projectUsers = 'project/users',

    //notifications
    notifications = '/notifications',

    //Update language
    updateLanguage = "/update_language",

    // Work Order
    workOrder = '/workorder',

    //Services
    service = '/service',
    serviceMaterial = '/material/' + MaterialLinkTypes.SERVICE,
    serviceUsers = '/service/users',
    // Time Managemenet
    timeManagement = '/add_time_management',
    displayTimeManagement = '/get_all_time_management',
    displayTimeManagementById = '/get_time_management_by_id',
    deleteTimeManagementById ='/delete_time_management',
    dispalyAllActivites ='/get_all_activities_data',
    getTimeManagementAbsences = '/get_time_management_absences',
    saveTimeManageAbsenceData = '/save_time_manage_absence_data',
    getTimeManageAbsenceDataById = '/get_time_manage_absence_data',
    deleteTimeManageAbsenceData = '/delete_time_manage_absence_data',
    employeeHasAbsenceOnDate = '/employee_has_absence_on_date',
    getActiveTimeEntry = '/get_active_entry', 
    pauseResumeTimeEntry = '/pause_resume_entry',
    getDailySummary='/get_daily_summary',

    // training
    training = '/training'
}
